module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"RecordJet Homepage Takeover","short_name":"recordjet-hpto","start_url":"/","background_color":"#FFFFFF","theme_color":"#FFFFFF","display":"minimal-ui","icon":"src/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5f0ab621c3f4aeac4c7a9ecc9769be22"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
